import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useOnClickOutside } from '../../lib/OnClickOutside'
import { FormModal } from '../basicForm/FormModal'
import { useDeleteCall } from '../../lib/api/delete'

import studentsIcon from '../../assets/images/students-icon.png'
import userIcon from '../../assets/images/user-icon.png'
import appIcon from '../../assets/images/app-icon.jpg'
import { DeleteConfirmModal } from './DeleteConfirmModal'
import { captureFinger } from '../../lib/fpFuncs'
import { ChildForm } from '../basicForm/ChildForm'
import { DocManager } from './DocManager'
import { FeeStatement } from '../basicForm/FeeStatement'

var quality = 60
var timeout = 10

export const ListCard = ({
  envData,
  data,
  dataToDisplay,
  modSchema,
  openEditFormModal,
  setOpenEditFormModal,
  listKey,
  defaultData,
  selectEditFormModal,
  openFormEdit,
  isViewOnly,
  setIsViewOnly,
  authDetails,
  isLocalEnvironment,
}) => {
  const [openOptions, setOpenOptions] = React.useState(false)
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)
  const [childForm, setChildForm] = React.useState(false)
  const [childFormData, setChildFormData] = React.useState(null)
  const [modalSchema, setModalSchema] = React.useState(null)
  const [docManager, setDocManager] = React.useState(false)
  const [fpError, setFPError] = React.useState(false)
  const [fpResponse, setFPResponse] = React.useState(null)
  const [winWidth, setWinWidth] = React.useState(window.innerWidth)
  const [feeStatementData, setFeeStatementData] = React.useState(null)
  const [feeReceiptsData, setFeeReceiptsData] = React.useState(null)
  const [feeStatement, setFeeStatement] = React.useState(false)
  const [feeStatementId, setFeeStatementId] = React.useState(null)
  const [filterById, setFilterById] = React.useState(null)
  const getFeeStatement = (id, d, dataId) => {
    setFilterById(dataId)
    setFeeStatementId(id)
    setFeeStatement(true)
    setFeeStatementData(d)
    setFeeReceiptsData(d.feeReceipts)
  }

  React.useEffect(() => {
    function handleResize() {
      setWinWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const openChildForm = (data, modalFormSchema) => {
    setChildForm(true)
    setChildFormData(data)
    setModalSchema(modalFormSchema)
  }

  const closeChildForm = () => {
    setChildForm(false)
    setChildFormData(null)
    setModalSchema(null)
  }

  const openOptionsRef = React.useRef()
  useOnClickOutside(openOptionsRef, () => setOpenOptions(false))

  const deleteCallMutation = useDeleteCall()
  const del = () => {
    setDeleteConfirm(true)
  }

  const goAheadDelete = async () => {
    await deleteCallMutation.mutateAsync({
      url: isLocalEnvironment + '/deleteData',
      apiEndpoint: modSchema.form.update.formAPI,
      id: data[modSchema.form.update.id],
      messageTitle: modSchema.form.update.deleteMessage.title,
      message: modSchema.form.update.deleteMessage.message,
      isDynamic: true,
    })
    setDeleteConfirm(false)
  }

  const fingerCap = async (f, d) => {
    sessionStorage.removeItem('mfsFP')
    await captureFinger(f, d, setFPError, setFPResponse)
  }

  const noRowFormAccess = () => {
    let accessTo = true
    modSchema.noRowFormAccessTo &&
      modSchema.noRowFormAccessTo.length > 0 &&
      modSchema.noRowFormAccessTo.map((e) => {
        if (authDetails.role === e) {
          accessTo = false
          return false
        }
      })
    return accessTo
  }

  const noModalRowFormAccess = () => {
    let accessTo = true
    modSchema.noModalRowFormAccessTo &&
      modSchema.noModalRowFormAccessTo.length > 0 &&
      modSchema.noModalRowFormAccessTo.map((e) => {
        if (authDetails.role === e) {
          accessTo = false
          return false
        }
      })
    return accessTo
  }

  const noUpdateDelete = () => {
    let accessTo = true

    modSchema.noUpdateDelete &&
      modSchema.noUpdateDelete.length > 0 &&
      modSchema.noUpdateDelete.map((e) => {
        if (authDetails.role === e) {
          accessTo = false
          return false
        }
      })
    return accessTo
  }

  return (
    <>
      <div className="trtui-col-xxl-3 trtui-col-sm-6 trtui-project-card">
        <div className="trtui-card trtui-card-height-100">
          <div className="trtui-card-body">
            <div className="trtui-d-flex trtui-flex-column trtui-h-100">
              <div className="trtui-d-flex">
                <div className="trtui-flex-grow-1">
                  <p className="trtui-text-muted trtui-mb-4">
                    {dataToDisplay.header
                      ? defaultData.formData[listKey][dataToDisplay.header.data]
                      : null}
                  </p>
                </div>
                <div className="trtui-flex-shrink-0">
                  <div className="trtui-d-flex trtui-gap-1 trtui-align-items-center">
                    <div className="trtui-dropdown">
                      <button
                        className="trtui-btn trtui-btn-link trtui-text-muted trtui-p-1 trtui-mt-n2 trtui-py-0 trtui-text-decoration-none trtui-fs-15"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                        onClick={() => setOpenOptions(!openOptions)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="trtui-feather trtui-feather-more-horizontal trtui-icon-sm"
                        >
                          <circle cx={12} cy={12} r={1} />
                          <circle cx={19} cy={12} r={1} />
                          <circle cx={5} cy={12} r={1} />
                        </svg>
                      </button>
                      <div
                        ref={openOptionsRef}
                        className={`trtui-dropdown-menu trtui-dropdown-menu-end ${
                          openOptions && 'trtui-show'
                        }`}
                        style={{
                          position: 'absolute',
                          inset: '0px 0px auto auto',
                          margin: '0px',
                          transform: 'translate(0px, 22px)',
                        }}
                      >
                        {noRowFormAccess() && modSchema.isRowForm && (
                          <span
                            className="trtui-dropdown-item trtui-cursor-pointer"
                            // onClick={() => openFormEdit(data, true)}
                            onClick={() =>
                              openChildForm(
                                defaultData.formData[listKey][modSchema.rowForm.rowDataArray],
                                modSchema.rowForm,
                              )
                            }
                          >
                            <i className="ri-user-add-line trtui-align-bottom trtui-me-2 trtui-text-muted" />{' '}
                            {modSchema.rowForm.formTitle}
                          </span>
                        )}
                        <span
                          className="trtui-dropdown-item trtui-cursor-pointer"
                          onClick={() => openFormEdit(data, true)}
                        >
                          <i className="ri-eye-fill trtui-align-bottom trtui-me-2 trtui-text-muted" />{' '}
                          View
                        </span>
                        {noUpdateDelete() && (
                          <>
                            <span
                              className="trtui-dropdown-item trtui-cursor-pointer"
                              onClick={() => openFormEdit(data)}
                            >
                              <i className="ri-pencil-fill trtui-align-bottom trtui-me-2 trtui-text-muted" />{' '}
                              Edit
                            </span>
                            <div className="dropdown-divider" />
                            <span
                              className="trtui-dropdown-item trtui-cursor-pointer"
                              onClick={del}
                              data-bs-toggle="modal"
                              data-bs-target="#removeProjectModal"
                            >
                              <i className="ri-delete-bin-fill trtui-align-bottom trtui-me-2 trtui-text-muted" />{' '}
                              Delete
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="trtui-d-flex trtui-mb-2">
                <div className="trtui-flex-shrink-0 trtui-me-3">
                  <div className="trtui-avatar-sm">
                    <span className="trtui-avatar-title trtui-bg-warning-subtle trtui-rounded trtui-p-2">
                      <img
                        src={
                          dataToDisplay.iconImg === 'userIcon'
                            ? userIcon
                            : dataToDisplay.iconImg === 'studentsIcon'
                              ? studentsIcon
                              : appIcon
                        }
                        alt=""
                        className="trtui-img-fluid trtui-p-1"
                      />
                    </span>
                  </div>
                </div>
                <div className="trtui-flex-grow-1">
                  <h5 className="trtui-mb-1 trtui-fs-15">
                    <span className="trtui-text-body">
                      {dataToDisplay.title
                        ? defaultData.formData[listKey][dataToDisplay.title.data]
                        : null}
                    </span>
                  </h5>
                  <p className="trtui-text-muted trtui-text-truncate-two-lines trtui-mb-3">
                    {dataToDisplay.small1
                      ? dataToDisplay.small1.isDate
                        ? dayjs(defaultData.formData[listKey][dataToDisplay.small1.data]).format(
                            envData.REACT_APP_DATE_FORMAT,
                          )
                        : defaultData.formData[listKey][dataToDisplay.small1.data]
                      : null}{' '}
                    {dataToDisplay.small2 ? (
                      <>
                        |{' '}
                        {dataToDisplay.small2.isDate
                          ? dayjs(defaultData.formData[listKey][dataToDisplay.small2.data]).format(
                              envData.REACT_APP_DATE_FORMAT,
                            )
                          : defaultData.formData[listKey][dataToDisplay.small2.data]}
                      </>
                    ) : null}
                  </p>
                </div>
              </div>
              {modSchema.captureFingerPrint &&
                ((defaultData.formData[listKey] &&
                  defaultData.formData[listKey].applicationStatus === 'APPROVED') ||
                  modSchema.moduleName === 'Users' ||
                  modSchema.moduleName === 'Staff') && (
                  <div className="trtui-ms-auto">
                    <div className="trtui-d-flex">
                      <div className="trtui-flex-shrink-0">
                        {defaultData.formData[listKey][modSchema.fingerPrintField] ? (
                          <div>
                            {fpError && (
                              <div className="trtui-text-danger trtui-text-bold">
                                Something went wrong! please try again
                              </div>
                            )}
                            {!fpError && fpResponse === 'success' && (
                              <div className="trtui-text-success trtui-text-bold">
                                Updated Fingerprint!
                              </div>
                            )}
                            <div className="trtui-text-success">Fingerprint Captured</div>
                            <button
                              type="button"
                              className="trtui-btn trtui-btn-primary trtui-btn-sm"
                              onClick={() => fingerCap(quality, timeout)}
                            >
                              <i className="ri-fingerprint-line trtui-align-bottom trtui-me-1" />{' '}
                              Update Fingerprint
                            </button>
                          </div>
                        ) : (
                          <div>
                            {fpError && (
                              <div className="trtui-text-danger trtui-text-bold">
                                Something went wrong! please try again
                              </div>
                            )}
                            {!fpError && fpResponse === 'success' && (
                              <div className="trtui-text-success trtui-text-bold">
                                Captured Fingerprint!
                              </div>
                            )}
                            <div className="trtui-text-danger">No Fingerprint!</div>
                            <button
                              type="button"
                              className="trtui-btn trtui-btn-primary trtui-btn-sm"
                              onClick={() => fingerCap(quality, timeout)}
                            >
                              <i className="ri-fingerprint-line trtui-align-bottom trtui-me-1" />{' '}
                              Capture Fingerprint
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              {modSchema.hasDocuments && (
                <div className="trtui-ms-auto" style={{ marginTop: '0.2rem' }}>
                  <div className="trtui-d-flex">
                    <div className="trtui-flex-shrink-0">
                      <div>
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-primary trtui-btn-sm"
                          onClick={() => setDocManager(true)}
                        >
                          <i className="ri-folder-2-line trtui-align-bottom trtui-me-1" /> Documents
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {modSchema.hasFeeStatement && (
                <div className="" style={{ marginTop: '0.2rem' }}>
                  <div className="trtui-d-flex">
                    <div className="trtui-flex-shrink-0">
                      <div>
                        <button
                          type="button"
                          className="trtui-btn trtui-btn-secondary trtui-btn-sm"
                          onClick={() =>
                            getFeeStatement(
                              defaultData.formData[listKey][modSchema.feeStatementId],
                              defaultData.formData[listKey],
                              defaultData.formData[listKey][modSchema.parentId],
                            )
                          }
                        >
                          <i className="ri-currency-line trtui-align-bottom trtui-me-1" /> Fee
                          Statement
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {noModalRowFormAccess() && modSchema.isModalRowForm && (
            <div className="trtui-card-footer trtui-bg-transparent trtui-border-top-dashed">
              <div className="trtui-d-flex trtui-align-items-center">
                <div className="trtui-d-flex trtui-flex-wrap">
                  {modSchema.modalRowForm.map((modalForm, modalFormIndex) => (
                    <div
                      key={`${modalForm}${modalFormIndex}`}
                      style={{ marginBottom: winWidth < 1120 ? '0.2rem' : '0px' }}
                      className="trtui-avatar-group"
                    >
                      <div className="trtui-hoverTT-main-example">
                        <span>
                          <button
                            type="button"
                            data-tooltip-id={modalForm.rowDataArray}
                            className="trtui-btn trtui-btn-outline-primary trtui-btn-icon trtui-waves-effect trtui-waves-light"
                            title={modalForm.formTitle}
                            onClick={() =>
                              openChildForm(
                                defaultData.formData[listKey][modalForm.rowDataArray],
                                modalForm,
                              )
                            }
                          >
                            {modalForm.iconText ? (
                              modalForm.iconText
                            ) : (
                              <i className="ri-add-line" />
                            )}
                          </button>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {childForm && (
            <ChildForm
              key={childFormData}
              listKey={listKey}
              defaultData={selectEditFormModal}
              parentData={defaultData.formData[listKey]}
              modalSchema={modalSchema}
              childFormData={childFormData}
              setChildFormData={setChildFormData}
              closeChildForm={closeChildForm}
              envData={envData}
              isLocalEnvironment={isLocalEnvironment}
            />
          )}
          {openEditFormModal && selectEditFormModal !== null && (
            <FormModal
              id={listKey}
              setOpenFormModal={setOpenEditFormModal}
              formSchema={modSchema.form.update}
              modSchema={modSchema.form.update}
              defaultData={selectEditFormModal}
              isViewOnly={isViewOnly}
              setIsViewOnly={setIsViewOnly}
              envData={envData}
              isLocalEnvironment={isLocalEnvironment}
            />
          )}
          {docManager && (
            <DocManager
              id={listKey}
              envData={envData}
              isLocalEnvironment={isLocalEnvironment}
              setOpenFormModal={setDocManager}
              formSchema={modSchema.form.update}
              modSchema={modSchema}
              defaultData={defaultData.formData[listKey]}
              isViewOnly={isViewOnly}
              setIsViewOnly={setIsViewOnly}
              authDetails={authDetails}
            />
          )}
          {feeStatement && (
            <FeeStatement
              key={feeStatementId}
              modSchema={modSchema}
              feeStatementData={feeStatementData}
              feeReceiptsData={feeReceiptsData}
              setFeeStatementId={setFeeStatementId}
              setFeeStatement={setFeeStatement}
              filterById={filterById}
              applicationDetails={defaultData.formData[listKey]}
            />
          )}
        </div>
      </div>
      {deleteConfirm && (
        <DeleteConfirmModal
          setDeleteConfirm={setDeleteConfirm}
          goAheadDelete={goAheadDelete}
          deleteCallMutation={deleteCallMutation}
        />
      )}
    </>
  )
}

ListCard.propTypes = {
  envData: PropTypes.object,
  data: PropTypes.object,
  routeDetails: PropTypes.object,
  dataToDisplay: PropTypes.object,
  modSchema: PropTypes.object,
  openEditFormModal: PropTypes.bool,
  setOpenEditFormModal: PropTypes.func,
  listKey: PropTypes.number,
  defaultData: PropTypes.object,
  selectEditFormModal: PropTypes.object,
  openFormEdit: PropTypes.func,
  isViewOnly: PropTypes.bool,
  setIsViewOnly: PropTypes.func,
  authDetails: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
}
